export const etchingSvgPattern = `<svg height="100" width="100" xmlns="http://www.w3.org/2000/svg" version="1.1"> 
  <defs> 
    <pattern id="bg-hatched-metal" patternUnits="userSpaceOnUse" width="100" height="100"> 
      <image href="https://content.solostove.com/image/upload/h_100,w_100/f_auto,q_auto/transform/185eb9b3-3926-40e5-a2dc-0aab09616609/etch-color-new-5" 
        x="0" y="0" width="100" height="100">
      </image> 
    </pattern> 
  </defs> 
</svg>`;
export const textSvgPattern = `<svg height="100" width="100" xmlns="http://www.w3.org/2000/svg" version="1.1"> 
  <defs> 
    <pattern id="bg-svg-text" patternUnits="userSpaceOnUse" width="5" height="5"> 
      <image href="https://content.solostove.com/image/upload/h_100,w_100/f_auto,q_auto/transform/185eb9b3-3926-40e5-a2dc-0aab09616609/etch-color-new-5" x="0" y="0" width="25" height="25">
      </image> 
    </pattern> 
  </defs> 
</svg>`;
